const ObjectPathImmutable = require('object-path-immutable');

module.exports = ObjectPathImmutable;
